export default "__VITE_ASSET__cd2c9578__"